import {Box, Skeleton, Stack, Typography} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

export default function LoadingChatUI() {
  return (
    <Box pt={0} px={1}>
      <Stack direction="row" spacing={1} alignItems={"center"}>
        <AutoAwesomeIcon
          sx={{
            fontSize: "0.875rem",
            animation: "scale 3s infinite ease-in-out",
            "@keyframes scale": {
              "0%, 100%": {
                transform: "scale(1)",
              },
              "50%": {
                transform: "scale(1.1)",
              },
            },
          }}
        />
        <Typography fontSize={"0.875rem"} fontWeight={500} sx={{ml: 1}}>
          Generating response...
        </Typography>
      </Stack>
      <Box height={4} />
      <Stack>
        {[100, 100, 75].map((width, index) => (
          <Skeleton
            key={index}
            animation="wave"
            variant="text"
            width={`${width}%`}
            sx={{fontSize: "0.875rem", lineHeight: "1.25rem"}}
          />
        ))}
      </Stack>
    </Box>
  );
}
